import dayjsTZ from "./dayjs";

export const getOnlineEmployees = (dataList, subDataList) => {
  if (!subDataList?.length || !dataList) {
    return [];
  }
  let foundOnline = subDataList?.map((subEl) => {
    let user = dataList?.find((el) => el.userSub === subEl.userSub);
    if (!!user && !!user?.lastLoggedIn) {
      let active =
        dayjsTZ().diff(dayjsTZ(user.lastLoggedIn), "minutes", true) > 16
          ? false
          : true;
      return {
        ...subEl,
        isActive: active,
      };
    } else {
      return { ...subEl };
    }
  });
  return foundOnline;
};
